import { useState, useContext } from 'react';

import { AppContext } from 'commons-ui';
import _isNil from 'lodash/isNil';
import { ContentPropsT } from '../constants';

const useFilter = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { dateRange } = submittedData;
			let filterData: any = {};
			if (!_isNil(dateRange) && dateRange.length === 2) {
				filterData = {
					startTime: dateRange[0].getTime(),
					endTime: dateRange[1].getTime() + 86400000
				};
			}
			handleFilterSubmit(filterData);
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching refund requests data.', { type: 'error' });
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useFilter;
